import { ColorEnum } from '@/constants/color'
import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
    card: {
        borderWidth: 1,
        borderColor: ColorEnum.GRAY_300,
        borderRadius: 8,
        padding: 16,
    },
    cardCompact: {
        padding: 12,
    },
    topRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
    },
    name: {
        flexShrink: 1,
        minWidth: 0,
        color: ColorEnum.GRAY_900,
    },
    quantityAndPrice: {
        flexGrow: 2,
        flexShrink: 0,
        flexBasis: 'auto',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: 42,
        marginLeft: 8,
        minWidth: 0,
    },
    quantityAndPriceCompact: {
        gap: 8,
    },
    quantity: {
        color: ColorEnum.BRICK_600,
        textAlign: 'right',
        textTransform: 'lowercase',
    },
    price: {
        color: ColorEnum.GRAY_900,
        textAlign: 'right',
        minWidth: 85,
    },
    optionsContainer: {
        marginTop: 12,
        gap: 8,
    },
    optionRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
    },
    optionName: {
        flex: 1,
        color: ColorEnum.GRAY_900,
    },
    optionPrice: {
        color: ColorEnum.GRAY_900,
        textAlign: 'right',
    },
    containers: {
        gap: 8,
    },
    containersHeading: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
    },
    containersHeadingText: {
        color: ColorEnum.GRAY_600,
    },
    containerRow: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingLeft: 20,
        gap: 8,
    },
    containerName: {
        flex: 1,
        color: ColorEnum.GRAY_900,
    },
    containerPrice: {
        minWidth: 70,
        color: ColorEnum.GRAY_900,
        textAlign: 'right',
    },
    noteRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
        marginTop: 12,
    },
    noteText: {
        color: ColorEnum.GRAY_600,
        flexShrink: 1,
    },
    actionsContainer: {
        width: '100%',
    },
    actionsContent: {
        paddingTop: 12,
    },
})

export default styles
